import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { routes } from "./app.routes";
import { RouterModule } from "@angular/router";
import { MessagesModule } from "../app/components/messages/messages.module";
import { AuthService } from "./auth.service";
import {
  TranslateModule,
  TranslateLoader,
  TranslateService,
} from "@ngx-translate/core";

import {
  HttpClient,
  HTTP_INTERCEPTORS,
  HttpClientModule,
} from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { TableModule } from "primeng/table";
import { LayoutModule } from "@angular/cdk/layout";
import { LoginModule } from "./components/shared/login.module";
import { MainScreenModule } from "./components/frames/main-screen/main-screen.module";
import { EnvironmentHelper } from "./services/env.helper";
import { NavigationHelper } from "./services/navigation.helper";
import { QuillModule } from "ngx-quill";
import { AccordionModule } from "primeng/accordion";
import { CookieService } from "ngx-cookie-service";
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [],
  imports: [
    LayoutModule,
    MainScreenModule,
    CommonModule,
    LoginModule,
    HttpClientModule,
    TableModule,
    MessagesModule,
    AccordionModule,
    QuillModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(routes, { onSameUrlNavigation: "reload" }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    EnvironmentHelper,
    NavigationHelper,
    AuthService,
    TranslateService,
    CookieService,
  ],
})
export class AppModule {}
